export default "__VITE_ASSET__bbcf0602__"